export default __webpack_public_path__ + "static/media/product28_slides.1b50879a.webp";